import { useNavigate } from "react-router-dom";

export const useAuth = () => {
  const navigate = useNavigate();

  const login = (token: string | null, user: any) => {
    if (token) {
      localStorage.setItem("token", token);
    }
    localStorage.setItem("user", JSON.stringify(user));
    localStorage.setItem("isAuthenticated", "true");
  };

  const logout = async () => {
    try {
      await fetch("/api/logout", {
        method: "POST",
        credentials: "include",
      });
    } catch (error) {
      // Silent fail
    }

    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("isAuthenticated");

    navigate("/login");
  };

  const isAuthenticated = (): boolean => {
    return localStorage.getItem("isAuthenticated") === "true";
  };

  const getUser = () => {
    try {
      return JSON.parse(localStorage.getItem("user") || "{}");
    } catch {
      return {};
    }
  };

  const getToken = (): string | null => {
    return localStorage.getItem("token");
  };

  return {
    login,
    logout,
    isAuthenticated,
    getUser,
    getToken,
  };
};
